import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Button from "../../commons/button/button";
import "./single-product.css";
const SingleProduct = ({
  Title,
  Image,
  id,
  price,
  width,
  marginTop,
  marginLeft,
  marginRight,
  marginBottom,
}) => {
  return (
    <Fragment>
      <Link
        style={{ textDecoration: "none", color: "black" }}
        to={`/product/${id}`}
      >
        <div
          style={{
            width: `${width ? width : null}`,
            marginTop: `${marginTop ? marginTop : null}`,
            marginRight: `${marginRight ? marginRight : null}`,
            marginLeft: `${marginLeft ? marginLeft : null}`,
            marginBottom: `${marginBottom ? marginBottom : null}`,
          }}
          className="single_product_body"
        >
          <div className="single_product_image_body">
            <img src={Image} />
          </div>

          <div className="single_product_title">{Title}</div>
          <div className="single_product_button">
            <Button
              boxShadow="0px 0px 13px -3px #636e72"
              background="#a5c926"
              color="white"
              heigh="35px"
              width="140px"
              radius="23px"
              padding="0 5px"
            >
              <div className="price_text"> {price} تومان</div>
            </Button>
          </div>
        </div>
      </Link>
    </Fragment>
  );
};

export default SingleProduct;
